import { Link } from 'react-router-dom';
import { categories } from '@/mocks/videos';

export default function CategorySection() {
  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-6 md:mb-10">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">
            内容分类
          </h2>
          <p className="text-sm text-foreground-500 mt-1">海量内容，想看的这里都有</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-5 md:p-6 bg-background-50 rounded-lg hover:bg-primary-50 cursor-pointer transition-all duration-300"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center bg-accent-100 rounded-xl group-hover:bg-accent-500 transition-colors duration-300">
                <i className={`${cat.icon} text-xl md:text-2xl text-accent-600 group-hover:text-white transition-colors duration-300`}></i>
              </div>
              <span className="text-sm font-semibold text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {cat.name}
              </span>
              <p className="text-xs text-foreground-500 text-center leading-relaxed hidden sm:block">
                {cat.description}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}